<template>
  <div class="content">
    <ImageSelectWrapper
      class="d-flex flex-column justify-center align-center"
      :allowMultipleSelect="allowMultipleSelect"
      @selected="$emit('added', $event)"
    >
      <template slot-scope="{ selectFile, isDraggingFile }">
        <div
          class="uploader-container d-flex flex-column justify-center align-center"
          :class="{
            'uploader-container--dragging': isDraggingFile,
          }"
        >
          <v-icon :color="isDraggingFile ? 'blue' : 'grey'" large>
            mdi-image-plus
          </v-icon>

          <v-spacer class="mt-2 flex-grow-0" />

          <h2 class="mt-1 grey--text text--darken-2">
            {{ $t('media.drop_images_message') }}
          </h2>

          <v-spacer class="mt-1 flex-grow-0" />

          <p class="mb-0 grey--text">{{ $t('common.or') }}</p>

          <v-spacer class="mt-1 flex-grow-0" />

          <Button
            color="primary"
            :text="$t('media.browse_files_button')"
            @click="selectFile"
          />

          <v-spacer class="mb-3 flex-grow-0" />

          <p class="mb-0 grey--text text-overline">
            {{
              $t('media.supported_extensions_label', {
                supportedExtensions: $constants.images.acceptedExtensions.join(),
              })
            }}
          </p>
        </div>
      </template>
    </ImageSelectWrapper>
  </div>
</template>

<script>
import ImageSelectWrapper from '@/components/utils/MediaManagementWrapper/ImageSelectWrapper.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'GalleryEmptyState',

  components: {
    ImageSelectWrapper,
    Button,
  },

  props: {
    allowMultipleSelect: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 65vh;
}

.uploader-container {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: 2px dashed map-get($grey, base);
  overflow: hidden;
  transition: all 0.2s;

  &--dragging {
    background-color: var(--v-blue-lighten5);
    border-color: var(--v-primary-base);
  }
}
</style>
